/*
 * Project: forca
 * File Created: Wednesday, 12th January 2022 12:48:59 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useEffect, useState } from 'react';

import Karrusel from './karrusel.component';

import { INTERVAL } from './karrusel.config';
import { KarruselContainerProps } from './karrusel.definition';

let isPlaying = true;

export const KarruselContainer = (props: KarruselContainerProps) => {
	const [activeSlide, setActiveSlide] = useState(0);

	let slide = activeSlide;

	useEffect(() => {
		setTimeout(() => {
			slidePlayer();
		}, INTERVAL);
	}, []);

	const slidePlayer = () => {
		const { karruselList } = props;

		if (isPlaying) {
			if (slide < (karruselList.length - 1)) {
				slide++;
			} else {
				slide = 0;
			}

			setActiveSlide(slide);

			setTimeout(() => {
				slidePlayer();
			}, INTERVAL);
		}
	};

	const changeActiveSlide = (slide: number) => {
		isPlaying = false;
		setActiveSlide(slide);
	};

	const containerFunctions = {
		changeActiveSlide: changeActiveSlide.bind(this)
	};

	const containerProps = () => {
		const { currentBlock = null, karruselList, link } = props;
		const { overskrift, subTitle, linkText, isTransparent, elementMargin } = currentBlock;

		const items = [];

		if (karruselList.length > 0) {
			karruselList.map(item => {
				items.push({
					buttonText: item.currentBlock.overskrift,
					image: item.image
				});
			});
		}

		return {
			title: overskrift,
			subtitle: subTitle,
			isTransparent,
			linkText,
			link,
			items,
			activeSlide,
			elementMargin
		};
	};

	return (
		<Karrusel
			{ ...containerProps() }
			{ ...containerFunctions }
		/>
	);
};

export default KarruselContainer;